/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * URL helper class
 **/
define([], function(){


	class URLUtil {

		/**
		 * Returns the boardId from a content service URL
		 *
		 * @param {String} url - Content service URL
		 * @return {String} boardId or undefined if the input is invalid
		 * @example URLUtil.getBoardIdFromUrl('bi/v1/objects/ABC123DEF456')
		 */
		static getBoardIdFromUrl(url) {
			const boardId = url && url.slice(url.lastIndexOf('/') + 1);
			if (boardId) {
				return boardId;
			}
		}
	}

	return URLUtil;
});
